import { render, staticRenderFns } from "./LinkCertificationTrainingManagementForm.vue?vue&type=template&id=fa5bcf6c&scoped=true"
import script from "./LinkCertificationTrainingManagementForm.vue?vue&type=script&lang=js"
export * from "./LinkCertificationTrainingManagementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5bcf6c",
  null
  
)

export default component.exports